module.exports = __webpack_public_path__ + "static/media/china.bc3195b6.svg";